import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

const GpuRoleManagement = () => {
    const [gpuUsers, setGpuUsers] = useState([]);
    const [usernameInput, setUsernameInput] = useState('');
    const [selectedRemoveUser, setSelectedRemoveUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const toast = useRef(null);

    const getHeaders = () => {
        const headers = { "Content-Type": "application/json" };
        const token = localStorage.getItem("token");
        if (token) headers["Authorization"] = `Token ${token}`;
        return headers;
    };

    const showSuccess = (msg) => toast.current.show({ severity: 'success', summary: 'Başarılı', detail: msg, life: 3000 });
    const showError = (msg) => toast.current.show({ severity: 'error', summary: 'Hata', detail: msg, life: 3000 });

    const fetchGpuUsers = () => {
        setLoading(true);
        fetch("/api/gpu-role-management/", { headers: getHeaders() })
            .then(res => res.json())
            .then(data => {
                if (data.result) {
                    setGpuUsers(data.users);
                } else {
                    showError(data.message);
                }
            })
            .catch(() => showError("Kullanıcılar yüklenirken bir hata oluştu."))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchGpuUsers();
    }, []);

    const handleAddRole = () => {
        if (!usernameInput.trim()) {
            showError("Lütfen bir kullanıcı adı girin.");
            return;
        }
        setAddLoading(true);
        fetch("/api/gpu-role-management/", {
            headers: getHeaders(),
            method: "POST",
            body: JSON.stringify({ username: usernameInput.trim() })
        })
            .then(res => res.json())
            .then(data => {
                if (data.result) {
                    showSuccess(data.message);
                    setUsernameInput('');
                    fetchGpuUsers();
                } else {
                    showError(data.message);
                }
            })
            .catch(() => showError("Rol ekleme işlemi sırasında bir hata oluştu."))
            .finally(() => setAddLoading(false));
    };

    const handleRemoveRole = (userId) => {
        setRemoveLoading(true);
        fetch("/api/gpu-role-management/", {
            headers: getHeaders(),
            method: "DELETE",
            body: JSON.stringify({ user_id: userId })
        })
            .then(res => res.json())
            .then(data => {
                if (data.result) {
                    showSuccess(data.message);
                    setSelectedRemoveUser(null);
                    fetchGpuUsers();
                } else {
                    showError(data.message);
                }
            })
            .catch(() => showError("Rol kaldırma işlemi sırasında bir hata oluştu."))
            .finally(() => setRemoveLoading(false));
    };

    const dropdownOptions = gpuUsers.map(u => ({
        label: u.user__user_username,
        value: u.user_id
    }));

    const actionBodyTemplate = (rowData) => (
        <Button
            label="Rolü Al"
            icon="pi pi-times"
            className="p-button-danger p-button-sm"
            onClick={() => handleRemoveRole(rowData.user_id)}
        />
    );

    return (
        <div className="p-grid">
            <Toast ref={toast} />
            <div className="p-col-12">
                <div className="card">
                    <h5>GPU Talep Yönetimi</h5>
                    <p className="p-text-secondary" style={{ marginBottom: '1.5rem', color: '#6c757d' }}>
                        Kullanıcılara <strong>Gpu Talepcisi</strong> rolü atayın veya mevcut rolü kaldırın.
                    </p>

                    {/* Rol Ekle */}
                    <div className="card" style={{ background: '#f8f9fa', marginBottom: '1.5rem' }}>
                        <h6>Kullanıcıya Rol Ver</h6>
                        <div className="p-inputgroup" style={{ maxWidth: '520px' }}>
                            <InputText
                                value={usernameInput}
                                onChange={(e) => setUsernameInput(e.target.value)}
                                placeholder="Kullanıcı adı girin..."
                                onKeyDown={(e) => e.key === 'Enter' && handleAddRole()}
                            />
                            <Button
                                label="Ekle"
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={handleAddRole}
                                loading={addLoading}
                            />
                        </div>
                    </div>

                    {/* Rol Kaldır */}
                    <div className="card" style={{ background: '#f8f9fa', marginBottom: '1.5rem' }}>
                        <h6>Kullanıcıdan Rolü Kaldır</h6>
                        <div className="p-inputgroup" style={{ maxWidth: '520px' }}>
                            <Dropdown
                                value={selectedRemoveUser}
                                options={dropdownOptions}
                                onChange={(e) => setSelectedRemoveUser(e.value)}
                                placeholder="Kullanıcı seçin..."
                                filter
                                filterPlaceholder="Ara..."
                                style={{ flex: 1 }}
                                emptyMessage="Henüz rol atanmış kullanıcı yok."
                            />
                            <Button
                                label="Rolü Al"
                                icon="pi pi-minus"
                                className="p-button-danger"
                                onClick={() => selectedRemoveUser && handleRemoveRole(selectedRemoveUser)}
                                disabled={!selectedRemoveUser}
                                loading={removeLoading}
                            />
                        </div>
                    </div>

                    {/* Kullanıcı Tablosu */}
                    <h6>Gpu Talepcisi Rolüne Sahip Kullanıcılar</h6>
                    <DataTable
                        value={gpuUsers}
                        loading={loading}
                        emptyMessage="Henüz bu role sahip kullanıcı bulunmuyor."
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        responsiveLayout="scroll"
                    >
                        <Column field="user__user_username" header="Kullanıcı Adı" sortable />
                        <Column field="user__user_email" header="E-posta" sortable />
                        <Column body={actionBodyTemplate} header="İşlem" style={{ width: '10rem' }} />
                    </DataTable>
                </div>
            </div>
        </div>
    );
};

export default GpuRoleManagement;



// WEBPACK FOOTER //
// ./src/pages/modulemanagement/GpuRoleManagement.jsx